// Переводы текстов интерфейса: ключ — русский текст
const dict = {
 "Оптовый: {{v0}}": "Көтерме: {{v0}}",
 "вес клиента за один приход сверх порога считается по этой цене (если она ниже обычной)": "клиенттің бір келуде шектен асатын салмағы осы баға бойынша есептеледі (егер ол әдеттегіден төмен болса)",
 "свыше": "асатын",
 "кг —": "кг —",
 "Порог, кг за приход": "Шек, бір келуге кг",
 "Оптовый тариф, ₸/кг": "Көтерме тариф, ₸/кг",
 "свыше {{v0}} кг — {{v1}} ₸/кг": "{{v0}} кг-дан асса — {{v1}} ₸/кг",
 "Оптовый тариф филиала сохранён": "Филиалдың көтерме тарифі сақталды",
 "Оптовый тариф филиала убран": "Филиалдың көтерме тарифі алынды",
 "Очерёдность: личный тариф клиента (VIP, в карточке клиента) → тариф филиала → общий. Оптовый тариф действует только на вес сверх порога и только если он ниже обычного тарифа клиента.": "Реті: клиенттің жеке тарифі (VIP, клиент карточкасында) → филиал тарифі → жалпы. Көтерме тариф тек шектен асатын салмаққа және клиенттің әдеттегі тарифінен төмен болса ғана қолданылады.",
 "в т. ч. {{v0}} кг по {{v1}} ₸/кг (оптовый)": "оның ішінде {{v0}} кг — {{v1}} ₸/кг (көтерме)",
 "Имя клиента (необязательно)": "Клиенттің аты (міндетті емес)",
 "Имя клиента": "Клиенттің аты",
 "Скопировать приглашение": "Шақыруды көшіру",
 "Приглашение": "Шақыру",
 "Забрана курьером": "Курьер алды",
 "Покинула сортировочный центр": "Сұрыптау орталығынан шықты",
 "Прибыла на сортировочный центр": "Сұрыптау орталығына келді",
 "Передана курьеру для доставки": "Жеткізу үшін курьерге берілді",
 "Принята на складе в Китае": "Қытайдағы қоймаға қабылданды",
 "Возврат отправителю": "Жөнелтушіге қайтарылды",
 "Проблема с доставкой": "Жеткізуде мәселе бар",
 "В пути по Китаю": "Қытайда жолда",
 " (сегодня)": " (бүгін)",
 " · есть несохранённые изменения": " · сақталмаған өзгерістер бар",
 " · код {{v0}}": " · коды {{v0}}",
 " · тариф {{v0}}": " · тариф {{v0}}",
 " — не везде задана цена, счета не посчитаются": " — баға барлық жерде берілмеген, шоттар есептелмейді",
 " — не у всех задана ссылка на оплату": " — барлығында төлем сілтемесі берілмеген",
 "(Добавлен вручную)": "(Қолмен қосылған)",
 ", читается именно этот лист.": ", дәл осы парақ оқылады.",
 "ID филиала:": "Филиал ID:",
 "Username (ник из адреса доставки):": "Username (жеткізу мекенжайындағы лақап ат):",
 "Username латиницей": "Username латын әрпімен",
 "Username латиницей, например Berik7777": "Username латын әрпімен, мысалы Berik7777",
 "WhatsApp номер": "WhatsApp нөмірі",
 "username не указан": "username көрсетілмеген",
 "{{v0}} закладок обновлено": "{{v0}} бетбелгі жаңартылды",
 "{{v0}} закладок удалено": "{{v0}} бетбелгі жойылды",
 "{{v0}} обновить не удалось": "{{v0}} жаңарту мүмкін болмады",
 "{{v0}} треков и закладок удалено": "{{v0}} трек пен бетбелгі жойылды",
 "{{v0}} удалить не удалось": "{{v0}} жою мүмкін болмады",
 "{{v0}} ₸/кг": "{{v0}} ₸/кг",
 "{{v0}} ₸/кг ({{v1}})": "{{v0}} ₸/кг ({{v1}})",
 "· вес": "· салмағы",
 "· всего": "· барлығы",
 "· не задан общий тариф (раздел «Вес»)": "· жалпы тариф берілмеген («Салмақ» бөлімі)",
 "· сумма": "· сомасы",
 "· тариф": "· тариф",
 "· уже выставлено:": "· шот қойылып қойған:",
 "» нет на сайте. Проверьте написание. Если человек ещё не зарегистрирован, запись можно сохранить: счёт выставится после его регистрации с таким username.": "» сайтта жоқ. Жазылуын тексеріңіз. Адам әлі тіркелмеген болса, жазбаны сақтауға болады: шот ол осы username-мен тіркелгеннен кейін шығарылады.",
 "Админ панель": "Әкімші панелі",
 "Адрес склада (его видит клиент в разделе «Склад»)": "Қойма мекенжайы (клиент оны «Қойма» бөлімінде көреді)",
 "Адрес филиала:": "Филиал мекенжайы:",
 "Адресс китайского склада": "Қытай қоймасының мекенжайы",
 "Аккаунт": "Аккаунт",
 "Аккаунт и пароль": "Аккаунт және құпия сөз",
 "Баллы": "Ұпайлар",
 "Баннеры": "Баннерлер",
 "Бонусы обновлены": "Бонустар жаңартылды",
 "В таблице": "Кестеде",
 "Ваш сайт": "Сіздің сайтыңыз",
 "Введите ID филиала": "Филиал ID-ін енгізіңіз",
 "Введите адрес филиала": "Филиал мекенжайын енгізіңіз",
 "Введите корректную сумму": "Дұрыс сома енгізіңіз",
 "Введите название филиала": "Филиал атауын енгізіңіз",
 "Введите новый пароль": "Жаңа құпия сөзді енгізіңіз",
 "Введите номер телефона пользователя": "Пайдаланушының телефон нөмірін енгізіңіз",
 "Введите текст статуса": "Статус мәтінін енгізіңіз",
 "Вес (кг)": "Салмағы (кг)",
 "Вес, кг": "Салмағы, кг",
 "Взять текущий текст": "Ағымдағы мәтінді алу",
 "Вперёд →": "Алға →",
 "Время": "Уақыты",
 "Вручную": "Қолмен",
 "Все": "Барлығы",
 "Все пользователи": "Барлық пайдаланушылар",
 "Все поля пустые": "Барлық өрістер бос",
 "Все статусы": "Барлық статустар",
 "Все треки": "Барлық треклер",
 "Все уровни": "Барлық деңгейлер",
 "Все филиалы": "Барлық филиалдар",
 "Всего треков:": "Барлық треклер:",
 "Вы уверены, что хотите удалить пользователя?": "Пайдаланушыны жойғыңыз келетініне сенімдісіз бе?",
 "Вы уверены, что хотите удалить этот филиал?": "Бұл филиалды жойғыңыз келетініне сенімдісіз бе?",
 "Выберите дату": "Күнді таңдаңыз",
 "Выберите дату и статус": "Күн мен статусты таңдаңыз",
 "Выберите клиента": "Клиентті таңдаңыз",
 "Выберите статус": "Статусты таңдаңыз",
 "Выберите филиал:": "Филиалды таңдаңыз:",
 "Выбрать все в статусе": "Статустағы барлығын таңдау",
 "Выбрать всё": "Барлығын таңдау",
 "Выбрать статус": "Статусты таңдау",
 "Выставить": "Шот қою",
 "Выставить {{v0}} счетов на {{v1}}? Клиенты получат уведомления{{v2}}.": "{{v1}} сомасына {{v0}} шот қою керек пе? Клиенттер хабарландыру алады{{v2}}.",
 "Выставить {{v0}} счетов на сумму {{v1}} за {{v2}}? Клиенты получат уведомления.": "{{v2}} күні үшін {{v1}} сомасына {{v0}} шот қою керек пе? Клиенттер хабарландыру алады.",
 "Выставить счета": "Шоттар қою",
 "Выставить счета ({{v0}})": "Шоттар қою ({{v0}})",
 "Выставлено счетов: {{v0}} на {{v1}}{{v2}}": "Шоттар қойылды: {{v0}}, сомасы {{v1}}{{v2}}",
 "Выставлено счетов: {{v0}} на {{v1}}{{v2}}.{{v3}}": "Шоттар қойылды: {{v0}}, сомасы {{v1}}{{v2}}.{{v3}}",
 "Глобальный процент успешно обновлен": "Жаһандық пайыз сәтті жаңартылды",
 "Да, удалить": "Иә, жою",
 "Данные профиля отсутствуют или ещё загружаются.": "Профиль деректері жоқ немесе әлі жүктелуде.",
 "Данные успешно обновлены": "Деректер сәтті жаңартылды",
 "Данные успешно сохранены": "Деректер сәтті сақталды",
 "Данные успешно сохранены:": "Деректер сәтті сақталды:",
 "Дата регистрации": "Тіркелген күні",
 "Дата создания": "Жасалған күні",
 "Дата статуса": "Статус күні",
 "Дата статуса:": "Статус күні:",
 "Действие": "Әрекет",
 "Действия": "Әрекеттер",
 "Добавить": "Қосу",
 "Добавить в базу": "Базаға қосу",
 "Добавить примечание": "Ескертпе қосу",
 "Добавить счёт для": "Мына клиентке шот қосу:",
 "Добавить трек": "Трек қосу",
 "Добавить трек клиента": "Клиент тректін қосу",
 "Добавить трек номер": "Трек нөмірін қосу",
 "Добавить утерянный товар": "Жоғалған тауарды қосу",
 "Добавить филиал": "Филиал қосу",
 "Добавлен": "Қосылған",
 "Добавлен вручную": "Қолмен қосылған",
 "Добавлена:": "Қосылған:",
 "Добавлено:": "Қосылды:",
 "Добавлено: {{v0}} — {{v1}}": "Қосылды: {{v0}} — {{v1}}",
 "Дополнительная информация": "Қосымша ақпарат",
 "Доступ запрещён": "Қолжетімділік жабық",
 "Доступ к таблице: «Все, у кого есть ссылка — Читатель». Если в ссылке есть": "Кестеге қолжетімділік: «Сілтемесі барлардың бәрі — Оқушы». Сілтемеде бар болса",
 "Загрузить": "Жүктеу",
 "Загрузить баннер": "Баннерді жүктеу",
 "Загрузить договор": "Шартты жүктеу",
 "Загрузить полную историю": "Толық тарихты жүктеу",
 "Закладка обновлена": "Бетбелгі жаңартылды",
 "Закладка удалена у пользователя": "Бетбелгі пайдаланушыдан жойылды",
 "Закрыть": "Жабу",
 "Записать всё равно": "Бәрібір жазу",
 "Записей": "Жазбалар",
 "Заполните все поля": "Барлық өрістерді толтырыңыз",
 "Из таблицы": "Кестеден",
 "Изменения успешно сохранены": "Өзгерістер сәтті сақталды",
 "Изменить": "Өзгерту",
 "Изменить вес": "Салмақты өзгерту",
 "Изменить статус": "Статусты өзгерту",
 "Изменить статус трека": "Трек статусын өзгерту",
 "Или введите трек-номер": "Немесе трек-нөмірді енгізіңіз",
 "Имя": "Аты",
 "Имя, телефон, username или код": "Аты, телефон, username немесе код",
 "Имя, телефон, личный код или username": "Аты, телефон, жеке код немесе username",
 "Информация": "Ақпарат",
 "История": "Тарих",
 "История (": "Тарих (",
 "История бонусов для": "Бонус тарихы:",
 "История обновлений:": "Жаңарту тарихы:",
 "История приходов": "Түсімдер тарихы",
 "История счетов": "Шоттар тарихы",
 "Итого:": "Барлығы:",
 "Ищу штрих-код… {{v0}}": "Штрих-код іздеп жатырмын… {{v0}}",
 "К выставлению": "Шот қоюға",
 "К выставлению:": "Шот қоюға:",
 "Камера не найдена. Сфотографируйте штрих-код или введите номер вручную.": "Камера табылмады. Штрих-кодты суретке түсіріңіз немесе нөмірді қолмен енгізіңіз.",
 "Клиент найден: {{v0}}": "Клиент табылды: {{v0}}",
 "Клиент:": "Клиент:",
 "Клиента «": "Клиент «",
 "Клиентов": "Клиенттер",
 "Клиенты увидят его в счёте": "Клиенттер оны шотта көреді",
 "Кол-во товаров": "Тауар саны",
 "Кол-во:": "Саны:",
 "Количество (шт)": "Саны (дана)",
 "Копию в Google сохранить не удалось: повторите кнопкой ниже.": "Google-ге көшірмені сақтау мүмкін болмады: төмендегі батырмамен қайталаңыз.",
 "Копия в Google не сохранена для записей:": "Google-дағы көшірме мына жазбалар үшін сақталмады:",
 "Копия сохранена в Google": "Көшірме Google-ге сақталды",
 "Копия сохранена в Google.": "Көшірме Google-ге сақталды.",
 "Личный (VIP)": "Жеке (VIP)",
 "Личный тариф пользователя (₸ за кг):": "Пайдаланушының жеке тарифі (кг үшін ₸):",
 "Личный тариф сохранён": "Жеке тариф сақталды",
 "Личный тариф убран": "Жеке тариф алынып тасталды",
 "Личный тариф, например 1400": "Жеке тариф, мысалы 1400",
 "Массовая загрузка": "Жаппай жүктеу",
 "Массовая загрузка утеренных товаров": "Жоғалған тауарларды жаппай жүктеу",
 "Массовое добавление": "Жаппай қосу",
 "Массовое добавление треков": "Тректерді жаппай қосу",
 "Мой карго": "Менің каргом",
 "На фото штрих-код не прочитался. Нужна резкая картинка, где код занимает заметную часть кадра (не меньше трети ширины). Или введите номер вручную.": "Фотодағы штрих-код оқылмады. Код кадрдың айтарлықтай бөлігін (енінің кемінде үштен бірін) алатын анық сурет қажет. Немесе нөмірді қолмен енгізіңіз.",
 "Нажмите на день в таблице, чтобы открыть его приходы.": "Күннің түсімдерін ашу үшін кестедегі күнді басыңыз.",
 "Название филиала:": "Филиал атауы:",
 "Найден пользователь: {{v0}} {{v1}}": "Пайдаланушы табылды: {{v0}} {{v1}}",
 "Найти": "Табу",
 "Например: заберите посылку до пятницы": "Мысалы: сәлемдемені жұмаға дейін алыңыз",
 "Например: оплатить до пятницы": "Мысалы: жұмаға дейін төлеңіз",
 "Начислить": "Есептеу",
 "Не выбрано": "Таңдалмаған",
 "Не добавлен": "Қосылмаған",
 "Не оплачены": "Төленбегендер",
 "Не удалось выставить счета": "Шоттарды қою мүмкін болмады",
 "Не удалось загрузить историю приходов": "Түсімдер тарихын жүктеу мүмкін болмады",
 "Не удалось загрузить оферту": "Оферта мәтінін жүктеу мүмкін болмады",
 "Не удалось загрузить приёмку": "Қабылдауды жүктеу мүмкін болмады",
 "Не удалось загрузить профиль": "Профильді жүктеу мүмкін болмады",
 "Не удалось загрузить файл": "Файлды жүктеу мүмкін болмады",
 "Не удалось запустить камеру. Сфотографируйте штрих-код или введите номер вручную.": "Камераны іске қосу мүмкін болмады. Штрих-кодты суретке түсіріңіз немесе нөмірді қолмен енгізіңіз.",
 "Не удалось изменить": "Өзгерту мүмкін болмады",
 "Не удалось найти посылку": "Сәлемдемені табу мүмкін болмады",
 "Не удалось обновить закладку": "Бетбелгіні жаңарту мүмкін болмады",
 "Не удалось обновить профиль": "Профильді жаңарту мүмкін болмады",
 "Не удалось открыть фото.": "Фотоны ашу мүмкін болмады.",
 "Не удалось отправить копию": "Көшірмені жіберу мүмкін болмады",
 "Не удалось прочитать таблицу": "Кестені оқу мүмкін болмады",
 "Не удалось разобрать фото. Введите номер вручную.": "Фотоны талдау мүмкін болмады. Нөмірді қолмен енгізіңіз.",
 "Не удалось создать счёт": "Шотты жасау мүмкін болмады",
 "Не удалось сохранить": "Сақтау мүмкін болмады",
 "Не удалось сохранить копию в Google": "Көшірмені Google-ге сақтау мүмкін болмады",
 "Не удалось удалить": "Жою мүмкін болмады",
 "Не удалось удалить файл": "Файлды жою мүмкін болмады",
 "Не читается? Нажмите «Сфотографировать код»: снимок обычно читается лучше, чем живая картинка.": "Оқылмай ма? «Кодты суретке түсіру» батырмасын басыңыз: сурет әдетте тікелей көріністен жақсы оқылады.",
 "Неизвестен": "Белгісіз",
 "Неизвестно": "Белгісіз",
 "Необходимо заполнить все поля": "Барлық өрістерді толтыру керек",
 "Нет выбранных закладок": "Таңдалған бетбелгілер жоқ",
 "Нет данных пользователя для загрузки": "Жүктейтін пайдаланушы деректері жоқ",
 "Нет записей, по которым ещё не выставлен счёт.": "Шот қойылмаған жазбалар жоқ.",
 "Нет операций": "Операциялар жоқ",
 "Нет рефералов": "Рефералдар жоқ",
 "Нет треков для добавления": "Қосатын треклер жоқ",
 "Ник из адреса доставки клиента. По нему распознаются этикетки посылок.": "Клиенттің жеткізу мекенжайындағы лақап ат. Сәлемдеме жапсырмалары осы арқылы танылады.",
 "Новые бонусы": "Жаңа бонустар",
 "Новый вес для {{v0}}, кг": "{{v0}} үшін жаңа салмақ, кг",
 "Новый пароль (оставьте пустым, чтобы не менять):": "Жаңа құпия сөз (өзгертпеу үшін бос қалдырыңыз):",
 "Новый процент": "Жаңа пайыз",
 "Новый счёт": "Жаңа шот",
 "Новый филиал успешно добавлен": "Жаңа филиал сәтті қосылды",
 "Номер": "Нөмірі",
 "Номер для звонка": "Қоңырау шалуға арналған нөмір",
 "Номер счёта": "Шот нөмірі",
 "Номер:": "Нөмірі:",
 "Обновить выбранные": "Таңдалғандарды жаңарту",
 "Обновить процент": "Пайызды жаңарту",
 "Обновить филиал": "Филиалды жаңарту",
 "Общая сумма": "Жалпы сома",
 "Общее кол-во": "Жалпы саны",
 "Общее примечание ко всем счетам (необязательно). Своё примечание клиенту можно написать в таблице выше": "Барлық шоттарға жалпы ескертпе (міндетті емес). Клиентке жеке ескертпені жоғарыдағы кестеге жазуға болады",
 "Общий": "Жалпы",
 "Общий вес": "Жалпы салмақ",
 "Общий тариф": "Жалпы тариф",
 "Общий тариф нужно указать числом, например 1800": "Жалпы тарифті сан түрінде көрсету керек, мысалы 1800",
 "Общий тариф сохранён": "Жалпы тариф сақталды",
 "Он показывается на странице «Публичная оферта» (доступна без входа). Если оставить поле пустым, показывается встроенный текст.": "Ол «Жария оферта» бетінде көрсетіледі (кірмей-ақ қолжетімді). Өріс бос болса, кірістірілген мәтін көрсетіледі.",
 "Описание": "Сипаттама",
 "Оплата и склад по филиалам": "Филиалдар бойынша төлем және қойма",
 "Оплачено": "Төленген",
 "Оплачены": "Төленгендер",
 "Открываю карточку…": "Карточканы ашып жатырмын…",
 "Открыть карточку клиента": "Клиент карточкасын ашу",
 "Открыть страницу": "Бетті ашу",
 "Открыть треки": "Тректерді ашу",
 "Отменены": "Күші жойылғандар",
 "Отменить": "Күшін жою",
 "Отменить счёт": "Шоттың күшін жою",
 "Отменить счёт {{v0}}?": "{{v0}} шотының күшін жою керек пе?",
 "Отмечен оплаченным": "Төленген деп белгіленді",
 "Отправить в Google": "Google-ге жіберу",
 "Отправить счёт": "Шотты жіберу",
 "Отправка...": "Жіберілуде...",
 "Оферта сохранена": "Оферта сақталды",
 "Очерёдность: личный тариф клиента (VIP, в карточке клиента) → тариф филиала → общий.": "Басымдылық реті: клиенттің жеке тарифі (VIP, клиент карточкасында) → филиал тарифі → жалпы тариф.",
 "Ошибка": "Қате",
 "Ошибка при загрузке закладок": "Бетбелгілерді жүктеу кезінде қате шықты",
 "Ошибка при загрузке полной истории": "Толық тарихты жүктеу кезінде қате шықты",
 "Ошибка при загрузке пользователей": "Пайдаланушыларды жүктеу кезінде қате шықты",
 "Ошибка при загрузке рефералов": "Рефералдарды жүктеу кезінде қате шықты",
 "Ошибка при массовом добавлении треков": "Тректерді жаппай қосу кезінде қате шықты",
 "Ошибка при массовом обновлении": "Жаппай жаңарту кезінде қате шықты",
 "Ошибка при обновлении бонусов": "Бонустарды жаңарту кезінде қате шықты",
 "Ошибка при обновлении данных": "Деректерді жаңарту кезінде қате шықты",
 "Ошибка при обновлении процента пользователя": "Пайдаланушы пайызын жаңарту кезінде қате шықты",
 "Ошибка при операции": "Операция кезінде қате шықты",
 "Ошибка при оплате счёта": "Шотты төлеу кезінде қате шықты",
 "Ошибка при применении трека": "Тректі қолдану кезінде қате шықты",
 "Ошибка при редактировании счёта": "Шотты өңдеу кезінде қате шықты",
 "Ошибка при сканировании": "Сканерлеу кезінде қате шықты",
 "Ошибка при создании счёта": "Шотты жасау кезінде қате шықты",
 "Ошибка при сохранении глобального процента": "Жаһандық пайызды сақтау кезінде қате шықты",
 "Ошибка при сохранении данных": "Деректерді сақтау кезінде қате шықты",
 "Ошибка при сохранении данных:": "Деректерді сақтау кезінде қате шықты:",
 "Ошибка при сохранении изменений": "Өзгерістерді сақтау кезінде қате шықты",
 "Ошибка при удалении пользователя": "Пайдаланушыны жою кезінде қате шықты",
 "Ошибка при удалении счёта": "Шотты жою кезінде қате шықты",
 "Ошибка при удалении трека": "Тректі жою кезінде қате шықты",
 "Ошибка: {{v0}}": "Қате: {{v0}}",
 "Пароль должен содержать от 6 до 64 символов": "Құпия сөз 6-дан 64 таңбаға дейін болуы керек",
 "Партия (дата)": "Партия (күні)",
 "По статусам": "Статустар бойынша",
 "По филиалам": "Филиалдар бойынша",
 "Повторить загрузку": "Жүктеуді қайталау",
 "Подождите…": "Күте тұрыңыз…",
 "Подсветку включить не удалось.": "Жарықты қосу мүмкін болмады.",
 "Подтвердить": "Растау",
 "Поиск": "Іздеу",
 "Поиск по имени или телефону": "Аты немесе телефон бойынша іздеу",
 "Поиск по имени, фамилии или телефону": "Аты, тегі немесе телефон бойынша іздеу",
 "Поиск по клиенту, телефону, счёту...": "Клиент, телефон, шот бойынша іздеу...",
 "Пока пусто.": "Әзірге бос.",
 "Показать ещё": "Тағы көрсету",
 "Поле процента пустое": "Пайыз өрісі бос",
 "Поле трек не может быть пустым": "Трек өрісі бос болмауы керек",
 "Полная история загружена": "Толық тарих жүктелді",
 "Пользователи (упрощённый список)": "Пайдаланушылар (жеңілдетілген тізім)",
 "Пользователь": "Пайдаланушы",
 "Пользователь с номером {{v0}} не найден": "Нөмірі {{v0}} пайдаланушы табылмады",
 "Пользователь удалён": "Пайдаланушы жойылды",
 "Поместите штрих-код в зелёную рамку и держите ровно 1–3 секунды. Нажимать на экран не нужно — код читается сам.": "Штрих-кодты жасыл жақтауға қойып, 1–3 секунд бойы қозғалтпай ұстаңыз. Экранды басудың қажеті жоқ — код өздігінен оқылады.",
 "Последний отсканированный ID:": "Соңғы сканерленген ID:",
 "Посмотреть рефералов": "Рефералдарды қарау",
 "Посылка {{v0}} → {{v1}} {{v2}}{{v3}}": "Сәлемдеме {{v0}} → {{v1}} {{v2}}{{v3}}",
 "Посылка {{v0}}: {{v1}}. Выберите клиента вручную.": "Сәлемдеме {{v0}}: {{v1}}. Клиентті қолмен таңдаңыз.",
 "Потеряшки": "Жоғалған тауарлар",
 "Предедущая страница": "Алдыңғы бет",
 "Примечание для клиента (необязательно)": "Клиентке ескертпе (міндетті емес)",
 "Примечание к счетам (необязательно)": "Шоттарға ескертпе (міндетті емес)",
 "Примечание к счёту {{v0}} (клиент увидит его в счёте; пусто — убрать)": "{{v0}} шотына ескертпе (клиент оны шотта көреді; бос — алып тастау)",
 "Примечание сохранено": "Ескертпе сақталды",
 "Примечание только для этого клиента (например, ссылка на постамат)": "Тек осы клиентке арналған ескертпе (мысалы, поштамат сілтемесі)",
 "Принял": "Қабылдаған",
 "Приходы за": "Түсімдер:",
 "Приёмка": "Қабылдау",
 "Пробить сканером...": "Сканермен өткізу...",
 "Произошла ошибка при добавлении трека": "Тректі қосу кезінде қате шықты",
 "Произошла ошибка при добавлении/редактировании филиала": "Филиалды қосу/өңдеу кезінде қате шықты",
 "Произошла ошибка при удалении филиала": "Филиалды жою кезінде қате шықты",
 "Пропущено строк таблицы:": "Өткізіп жіберілген кесте жолдары:",
 "Профиль загружен": "Профиль жүктелді",
 "Профиль:": "Профиль:",
 "Процент": "Пайыз",
 "Процент пользователя обновлен": "Пайдаланушы пайызы жаңартылды",
 "Пусто — показывается встроенный текст. Нажмите «Взять текущий текст», чтобы начать с него.": "Бос — кірістірілген мәтін көрсетіледі. Одан бастау үшін «Ағымдағы мәтінді алу» батырмасын басыңыз.",
 "Разбираю фото… {{v0}}%": "Фотоны талдап жатырмын… {{v0}}%",
 "Разметка:": "Белгілеу:",
 "Разрешите доступ к камере в настройках браузера для этого сайта.": "Браузер параметрлерінде осы сайт үшін камераға рұқсат беріңіз.",
 "Рассылка": "Тарату",
 "Расширить": "Кеңейту",
 "Редактирование пользователя": "Пайдаланушыны өңдеу",
 "Редактировать": "Өзгерту",
 "Редактировать закладку": "Бетбелгіні өзгерту",
 "Реквизиты сохранены": "Деректемелер сақталды",
 "Рефералы пользователя:": "Пайдаланушының рефералдары:",
 "Роль": "Рөлі",
 "Роль:": "Рөлі:",
 "Свежие по дате": "Жаңалары алдымен",
 "Свернуть": "Жасыру",
 "Сейчас применяется:": "Қазір қолданылады:",
 "Сканер посылки": "Сәлемдеме сканері",
 "Сканер штрих-кода": "Штрих-код сканері",
 "Сканирование QR доступно только администраторам": "QR сканерлеу тек әкімшілерге қолжетімді",
 "Сканирование QR-кода": "QR кодты сканерлеу",
 "Сканирование посылок": "Сәлемдемелерді сканерлеу",
 "Сканировать QR": "QR сканерлеу",
 "Скачать файл": "Файлды жүктеп алу",
 "Сменить клиента": "Клиентті ауыстыру",
 "Сначала выберите дату и статус, потом сканируйте посылки": "Алдымен күн мен статусты таңдаңыз, содан кейін сәлемдемелерді сканерлеңіз",
 "Снять выбор": "Таңдауды алу",
 "Создать": "Жасау",
 "Создать счёт": "Шот жасау",
 "Создать/обновить трек {{v0}} в общей базе?": "{{v0}} трегін ортақ базада жасау/жаңарту керек пе?",
 "Создаётся автоматически из личного кода клиента: XXX-0001, XXX-0002…": "Клиенттің жеке кодынан автоматты түрде жасалады: XXX-0001, XXX-0002…",
 "Сортировка по активности": "Белсенділік бойынша сұрыптау",
 "Состояние": "Күйі",
 "Сохранение...": "Сақталуда...",
 "Сохранить": "Сақтау",
 "Сохранить изменения": "Өзгерістерді сақтау",
 "Списать": "Есептен шығару",
 "Списать/начислить баллы": "Ұпайларды шегеру/қосу",
 "Списать/начислить баллы для": "Мына клиентке ұпай шегеру/қосу:",
 "Список посылок": "Сәлемдемелер тізімі",
 "Список треков": "Треклер тізімі",
 "Список треков для массового добавления:": "Жаппай қосуға арналған треклер тізімі:",
 "Ссылка на Google-таблицу": "Google кестесіне сілтеме",
 "Ссылка на ватсап": "WhatsApp сілтемесі",
 "Ссылка на инструкцию (youtube, vimeo)": "Нұсқаулыққа сілтеме (youtube, vimeo)",
 "Ссылка на оплату (Kaspi и т.п.)": "Төлем сілтемесі (Kaspi және т.б.)",
 "Ссылка показывается клиенту кнопкой «Оплатить» в неоплаченном счёте. У каждого филиала своя.": "Сілтеме клиентке төленбеген шоттағы «Төлеу» батырмасы ретінде көрсетіледі. Әр филиалдың өз сілтемесі бар.",
 "Старые по дате": "Ескілері алдымен",
 "Статистика": "Статистика",
 "Статус": "Статус",
 "Статусы": "Статустар",
 "Сумма": "Сома",
 "Сумма (₸) *": "Сома (₸) *",
 "Сумма баллов": "Ұпай сомасы",
 "Сумма появится после ввода веса": "Сома салмақ енгізілгеннен кейін шығады",
 "Суммы расходятся со столбцом Payment в": "Сомалар мына жердегі Payment бағанымен сәйкес келмейді:",
 "Счета выставлены на": "Шоттар қойылды:",
 "Счета из таблицы поступлений": "Түсімдер кестесінен шоттар",
 "Счета отсутствуют": "Шоттар жоқ",
 "Счетов нет": "Шоттар жоқ",
 "Счёт отменён": "Шоттың күші жойылды",
 "Счёт отправлен клиенту": "Шот клиентке жіберілді",
 "Счёт удалён": "Шот жойылды",
 "Счёт успешно создан": "Шот сәтті жасалды",
 "Тариф": "Тариф",
 "Тариф филиала сохранён": "Филиал тарифі сақталды",
 "Тариф филиала убран — действует общий": "Филиал тарифі алынды — жалпы тариф қолданылады",
 "Тариф, ₸/кг": "Тариф, ₸/кг",
 "Тарифы, ₸/кг": "Тарифтер, ₸/кг",
 "Текст \"О нас\"": "\"Біз туралы\" мәтіні",
 "Текст \"Товары которые нельзя заказывать\"": "\"Тапсырыс беруге болмайтын тауарлар\" мәтіні",
 "Текст оферты.": "Оферта мәтіні.",
 "Текст очищен: будет показан встроенный вариант": "Мәтін тазартылды: кірістірілген нұсқа көрсетіледі",
 "Текущий договор:": "Ағымдағы шарт:",
 "Текущий статус:": "Ағымдағы статус:",
 "Текущий файл:": "Ағымдағы файл:",
 "Телефон:": "Телефон:",
 "Тип:": "Түрі:",
 "Требуется авторизация администратора": "Әкімші авторизациясы қажет",
 "Трек": "Трек",
 "Трек номер:": "Трек нөмірі:",
 "Трек применён в базе": "Трек базада қолданылды",
 "Трек удалён": "Трек жойылды",
 "Трека": "Трек",
 "Треки": "Треклер",
 "Треки (по статусам)": "Треклер (статустар бойынша)",
 "Треки клиента": "Клиент тректері",
 "Треки отсутствуют": "Треклер жоқ",
 "Треки прикрепленные пользователями, но не найденные": "Пайдаланушылар тіркеген, бірақ табылмаған треклер",
 "Треки успешно обновлены или созданы": "Треклер сәтті жаңартылды немесе жасалды",
 "Убрать": "Алып тастау",
 "Убрать у клиента": "Клиенттен алып тастау",
 "Удалить": "Жою",
 "Удалить {{v0}} закладок у пользователя и соответствующие треки из базы?": "Пайдаланушыдан {{v0}} бетбелгіні және базадан сәйкес треклерді жою керек пе?",
 "Удалить {{v0}} закладок у пользователя?": "Пайдаланушыдан {{v0}} бетбелгіні жою керек пе?",
 "Удалить выбранные из базы": "Таңдалғандарды базадан жою",
 "Удалить закладку {{v0}} у пользователя?": "{{v0}} бетбелгісін пайдаланушыдан жою керек пе?",
 "Удалить запись {{v0}} — {{v1}}?": "{{v0}} — {{v1}} жазбасын жою керек пе?",
 "Удалить из базы": "Базадан жою",
 "Удалить профиль": "Профильді жою",
 "Удалить счёт {{v0}} безвозвратно?": "{{v0}} шотын біржола жою керек пе?",
 "Удалить трек {{v0}} из системы? Это действие повлияет на всех пользователей.": "{{v0}} трегін жүйеден жою керек пе? Бұл барлық пайдаланушыларға әсер етеді.",
 "Укажите вес в кг, например 2.85": "Салмақты кг-мен көрсетіңіз, мысалы 2.85",
 "Укажите клиента": "Клиентті көрсетіңіз",
 "Укажите сумму больше нуля": "Нөлден үлкен соманы көрсетіңіз",
 "Уровень": "Деңгей",
 "Успешно загружено!!": "Сәтті жүктелді!!",
 "Установить": "Орнату",
 "Установить статус выбранным закладкам ({{v0}})?": "Таңдалған бетбелгілерге ({{v0}}) статус орнату керек пе?",
 "Файл загружен": "Файл жүктелді",
 "Файл оферты (PDF, DOC, DOCX)": "Оферта файлы (PDF, DOC, DOCX)",
 "Фамилия": "Тегі",
 "Филиал": "Филиал",
 "Филиал не указан": "Филиал көрсетілмеген",
 "Филиал успешно обновлен": "Филиал сәтті жаңартылды",
 "Филиал успешно удален": "Филиал сәтті жойылды",
 "Филиала": "Филиал",
 "Фильтр:": "Сүзгі:",
 "Фильтры и массовые операции — ниже. Нажмите «Открыть треки», чтобы начать работу.": "Сүзгілер мен жаппай операциялар төменде. Жұмысты бастау үшін «Тректерді ашу» батырмасын басыңыз.",
 "Функция еще в разработке...": "Бұл функция әлі әзірленуде...",
 "Хозяин посылки не найден, выберите клиента вручную": "Сәлемдеме иесі табылмады, клиентті қолмен таңдаңыз",
 "Цена за кг": "Кг бағасы",
 "Читаю…": "Оқып жатырмын…",
 "баллов —": "ұпай —",
 "без username": "username жоқ",
 "все счета выставлены": "барлық шоттар қойылды",
 "выставлен": "қойылды",
 "день": "күн",
 "добавлен ({{v0}})": "қосылды ({{v0}})",
 "ждут счёта:": "шот күтуде:",
 "запасной: для филиалов без своей цены": "қосалқы: өз бағасы жоқ филиалдар үшін",
 "изменить": "өзгерту",
 "изменить ▼": "өзгерту ▼",
 "индивидуальных примечаний: {{v0}}": "жеке ескертпелер: {{v0}}",
 "к выставлению": "шот қоюға",
 "как общий": "жалпыдай",
 "кг •": "кг •",
 "кг,": "кг,",
 "личный": "жеке",
 "меню": "мәзір",
 "не задан": "берілмеген",
 "не задан — показывается общий адрес": "берілмеген — жалпы мекенжай көрсетіледі",
 "не привязан": "байланыстырылмаған",
 "нет": "жоқ",
 "нет в базе. Проверьте номер или добавьте посылку.": "базада жоқ. Нөмірді тексеріңіз немесе сәлемдемені қосыңыз.",
 "нет приходов": "түсімдер жоқ",
 "нет ссылки": "сілтеме жоқ",
 "общий": "жалпы",
 "общий {{v0}}": "жалпы {{v0}}",
 "общий не задан": "жалпы берілмеген",
 "ожидает": "күтуде",
 "открыть": "ашу",
 "подробнее ▼": "толығырақ ▼",
 "с общим примечанием": "жалпы ескертпемен",
 "свернуть ▲": "жасыру ▲",
 "своя цена не задана — действует общая": "өз бағасы берілмеген — жалпы баға қолданылады",
 "сегодня": "бүгін",
 "ссылка есть": "сілтеме бар",
 "стр. {{v0}}: {{v1}}": "жол {{v0}}: {{v1}}",
 "строках (отмечены ⚠). Обычно это клиенты со скидкой: задайте им личный тариф в «Все пользователи → Изменить».": "жолдарда (⚠ белгіленген). Әдетте бұл жеңілдігі бар клиенттер: оларға «Барлық пайдаланушылар → Өзгерту» бөлімінде жеке тариф белгілеңіз.",
 "счетов ·": "шот ·",
 "тариф не задан": "тариф берілмеген",
 "тариф филиала": "филиал тарифі",
 "удалить": "жою",
 "указать": "көрсету",
 "шт •": "дана •",
 "шт,": "дана,",
 "— клиентов:": "— клиенттер:",
 "₸/кг": "₸/кг",
 "← Вернуться к информации": "← Ақпаратқа оралу",
 "← На сайт": "← Сайтқа",
 "← Назад": "← Артқа",
 "⏳ Ожидает": "⏳ Күтуде",
 "⚖️ Приёмка": "⚖️ Қабылдау",
 "✎ Примечание": "✎ Ескертпе",
 "✎ примечание": "✎ ескертпе",
 "✓ Выставить {{v0}} счетов": "✓ {{v0}} шот қою",
 "✓ Оплачено": "✓ Төленді",
 "✓ Отправить счёт": "✓ Шотты жіберу",
 "✕ Отмена": "✕ Бас тарту",
 "＋ Примечание": "＋ Ескертпе",
 "📋 Управление счетами": "📋 Шоттарды басқару",
 "📦 Треки (": "📦 Треклер (",
 "📷 Сканировать": "📷 Сканерлеу",
 "📷 Сканировать камерой телефона": "📷 Телефон камерасымен сканерлеу",
 "📷 Сканировать посылку": "📷 Сәлемдемені сканерлеу",
 "📸 Сфотографировать код": "📸 Кодты суретке түсіру",
 "🔦 Включить подсветку": "🔦 Жарықты қосу",
 "🔦 Выключить подсветку": "🔦 Жарықты өшіру",
 "🖼 Фото из галереи": "🖼 Галереядан фото",
 "% Глобальный процент партнера": "% Серіктестің жаһандық пайызы",
 "— выделение; абзацы разделяйте пустой строкой.": "— бөлектеу; абзацтарды бос жолмен бөліңіз.",
 "— заголовок документа;": "— құжат тақырыбы;",
 "— необязательно; ссылка на скачивание показывается на странице, если текст не задан.": "— міндетті емес; мәтін берілмесе, жүктеп алу сілтемесі бетте көрсетіледі.",
 "— подзаголовок;": "— қосымша тақырып;",
 "— раздел (сворачивается);": "— бөлім (жиналады);",
 "— список;": "— тізім;",
 "В файле не найдено треков": "Файлда треклер табылмады",
 "В файле больше 2000 треков — разбейте на части": "Файлда 2000-нан астам трек бар — бөліктерге бөліңіз",
 "Файл {{v0}}: найдено треков {{v1}}{{v2}}{{v3}}. Проверьте дату и статус и нажмите «Загрузить».": "{{v0}} файлы: {{v1}} трек табылды{{v2}}{{v3}}. Күні мен статусты тексеріп, «Жүктеу» батырмасын басыңыз.",
 ", код филиала {{v0}}": ", филиал коды {{v0}}",
 ", дата {{v0}}": ", күні {{v0}}",
 "Не удалось прочитать файл: {{v0}}": "Файлды оқу мүмкін болмады: {{v0}}",
 "📎 Загрузить файл (xlsx, csv, txt)": "📎 Файл жүктеу (xlsx, csv, txt)",
 "Вы уверены, что хотите удалить эту закладку?": "Бұл бетбелгіні жойғыңыз келетініне сенімдісіз бе?",
 "Закладка удалена": "Бетбелгі жойылды",
 "Ошибка при удалении закладки": "Бетбелгіні жою кезінде қате шықты",
 "Описание:": "Сипаттама:",
 "Загрузка...": "Жүктелуде...",
 "Подтвердить получение": "Алғанымды растау",
 "Токен отсутствует. Пожалуйста, войдите в систему снова.": "Токен жоқ. Жүйеге қайта кіріңіз.",
 "Username сохранён.": "Username сақталды.",
 "Не удалось сохранить username.": "Username сақтау мүмкін болмады.",
 "Ошибка при отправке запроса.": "Сұранысты жіберу кезінде қате шықты.",
 "Пароль успешно обновлен.": "Құпия сөз сәтті жаңартылды.",
 "Ошибка при смене пароля.": "Құпия сөзді өзгерту кезінде қате шықты.",
 "Заполните обязательные поля": "Міндетті өрістерді толтырыңыз",
 "Объявление обновлено": "Хабарландыру жаңартылды",
 "Объявление создано и отправлено всем пользователям": "Хабарландыру жасалып, барлық пайдаланушыларға жіберілді",
 "Ошибка при сохранении объявления": "Хабарландыруды сақтау кезінде қате шықты",
 "Вы уверены?": "Сенімдісіз бе?",
 "Объявление удалено": "Хабарландыру жойылды",
 "Ошибка при удалении объявления": "Хабарландыруды жою кезінде қате шықты",
 "Доступ запрещен": "Қолжетімділік жабық",
 "Управление объявлениями": "Хабарландыруларды басқару",
 "✕ Закрыть форму": "✕ Форманы жабу",
 "+ Новое объявление": "+ Жаңа хабарландыру",
 "Заголовок *": "Тақырып *",
 "Введите заголовок": "Тақырыпты енгізіңіз",
 "Сообщение *": "Хабарлама *",
 "Введите сообщение": "Хабарламаны енгізіңіз",
 "URL изображения": "Сурет URL-і",
 "💾 Обновить": "💾 Жаңарту",
 "💾 Создать": "💾 Жасау",
 "Отмена": "Бас тарту",
 "Объявления (": "Хабарландырулар (",
 "Объявлений нет": "Хабарландырулар жоқ",
 "Ошибка при загрузке архива": "Мұрағатты жүктеу кезінде қате шықты",
 "Запись удалена из архива": "Жазба мұрағаттан жойылды",
 "Ошибка при удалении": "Жою кезінде қате шықты",
 "Загрузка архива...": "Мұрағат жүктелуде...",
 "Архив пуст": "Мұрағат бос",
 "В архиве": "Мұрағатта",
 "УДАЛИТЬ": "ЖОЮ",
 "История статусов": "Статустар тарихы",
 "Добавлен в базу": "Базаға қосылды",
 "Загрузка…": "Жүктелуде…",
 "Показать ещё ({{v0}})": "Тағы көрсету ({{v0}})",
 "Архив": "Мұрағат",
 "Загрузка ...": "Жүктелуде ...",
 "Показано": "Көрсетілді",
 "из": "/",
 "архивированных посылок": "мұрағатталған сәлемдеме",
 "Дата регистрации клиентом:": "Клиент тіркелген күн:",
 "нет данных": "деректер жоқ",
 "Дата получения:": "Алынған күні:",
 "Страница": "Бет",
 "Баннер": "Баннер",
 "Логотип": "Логотип",
 "Надёжный карго-сервис с отслеживанием и прозрачной логистикой": "Бақылауы бар және ашық логистикалы сенімді карго-сервис",
 "Войти": "Кіру",
 "Регистрация": "Тіркелу",
 "Перейти в систему": "Жүйеге өту",
 "Публичная оферта": "Жария оферта",
 "Ошибка при обновлении и получении счета: {{v0}}": "Шотты жаңарту және алу кезінде қате: {{v0}}",
 "Загрузка счета...": "Шот жүктелуде...",
 "Нет неоплаченных счетов": "Төленбеген шоттар жоқ",
 "Счёт за доставку от": "Жеткізу шоты, күні:",
 "Поступило заказов -": "Түскен тапсырыстар -",
 "шт": "дана",
 "Вес": "Салмағы",
 "кг, сумма к оплате": "кг, төленетін сома",
 "Главная": "Басты бет",
 "Посылки": "Сәлемдемелер",
 "Профиль": "Профиль",
 "Панель управления": "Басқару тақтасы",
 "Поиск...": "Іздеу...",
 "Найдено:": "Табылды:",
 "Трек-код": "Трек-код",
 "Дата": "Күні",
 "Предыдущая страница": "Алдыңғы бет",
 "Следующая страница": "Келесі бет",
 "Номер страницы:": "Бет нөмірі:",
 "Кол-во страниц:": "Беттер саны:",
 "Доступен 09:00 - 18:00 (МСК)": "Қолжетімді 09:00 - 18:00 (МСК)",
 "Статус клиента": "Клиент мәртебесі",
 "Бонусные баллы": "Бонус ұпайлары",
 "Общие затраты": "Жалпы шығындар",
 "Рефералы": "Рефералдар",
 "Информация аккаунта": "Аккаунт туралы ақпарат",
 "Успешно добавлен": "Сәтті қосылды",
 "404 - Страница не найдена": "404 - Бет табылмады",
 "К сожалению, запрашиваемая страница не существует.": "Өкінішке қарай, сұралған бет жоқ.",
 "Вернуться на главную": "Басты бетке оралу",
 "Ошибка при получении уведомлений": "Хабарландыруларды алу кезінде қате шықты",
 "Уведомление удалено": "Хабарландыру жойылды",
 "Счета": "Шоттар",
 "Объявления": "Хабарландырулар",
 "Уведомления": "Хабарландырулар",
 "Загрузка уведомлений...": "Хабарландырулар жүктелуде...",
 "Нет уведомлений": "Хабарландырулар жоқ",
 "Трек:": "Трек:",
 "Сумма:": "Сомасы:",
 "Вес:": "Салмағы:",
 "кг": "кг",
 "Объявление": "Хабарландыру",
 "✓ Прочитано": "✓ Оқылды",
 "● Новое": "● Жаңа",
 "Получение подтверждено!": "Алғаныңыз расталды!",
 "Произошла ошибка при подтверждении получения.": "Алуды растау кезінде қате шықты.",
 "посылок": "сәлемдеме",
 "неизвестно": "белгісіз",
 "Данные скопированы в буфер обмена": "Деректер буферге көшірілді",
 "Не удалось скопировать — попробуйте вручную": "Көшіру мүмкін болмады — қолмен көшіріп көріңіз",
 "Не удалось получить доступ к камере": "Камераға қолжеткізу мүмкін болмады",
 "Клиент найден!": "Клиент табылды!",
 "Клиент не найден": "Клиент табылмады",
 "Ошибка при поиске клиента": "Клиентті іздеу кезінде қате шықты",
 "Сканирование клиентов через QR": "Клиенттерді QR арқылы сканерлеу",
 "Отсканируйте QR код клиента или введите номер телефона": "Клиенттің QR кодын сканерлеңіз немесе телефон нөмірін енгізіңіз",
 "⚠️ Доступ к камере запрещен": "⚠️ Камераға рұқсат жоқ",
 "Пожалуйста, разрешите доступ к камере в настройках браузера": "Браузер параметрлерінде камераға рұқсат беріңіз",
 "🛑 Остановить сканирование": "🛑 Сканерлеуді тоқтату",
 "📷 Начать сканирование": "📷 Сканерлеуді бастау",
 "Введите номер телефона клиента": "Клиенттің телефон нөмірін енгізіңіз",
 "🔍 Поиск": "🔍 Іздеу",
 "Загрузка данных клиента...": "Клиент деректері жүктелуде...",
 "Данные клиента": "Клиент деректері",
 "Имя:": "Аты:",
 "Номер телефона:": "Телефон нөмірі:",
 "Не указан": "Көрсетілмеген",
 "Статус:": "Мәртебесі:",
 "Администратор": "Әкімші",
 "Клиент": "Клиент",
 "Уровень:": "Деңгейі:",
 "Стандартный": "Стандартты",
 "Филиал:": "Филиал:",
 "Бонусы:": "Бонустар:",
 "Дата регистрации:": "Тіркелген күні:",
 "Реферальный код:": "Реферал коды:",
 "📷 Отсканировать другого": "📷 Басқасын сканерлеу",
 "Клиент с номером": "Нөмірі бар клиент",
 "не найден": "табылмады",
 "Попробовать снова": "Қайталап көру",
 "Реферальная ссылка скопирована!": "Реферал сілтемесі көшірілді!",
 "Пользователи, зарегистрированные по вашей реферальной ссылке": "Сіздің реферал сілтемеңіз арқылы тіркелген пайдаланушылар",
 "Фамилия:": "Тегі:",
 "Партнерская программа": "Серіктестік бағдарлама",
 "Ваша реферальная ссылка:": "Сіздің реферал сілтемеңіз:",
 "Пожалуйста, авторизуйтесь": "Жүйеге кіріңіз",
 "Мой QR код": "Менің QR кодым",
 "Покажите этот QR код администратору для быстрого поиска вашей информации": "Деректеріңізді жылдам табу үшін бұл QR кодты әкімшіге көрсетіңіз",
 "📥 Скачать QR код": "📥 QR кодты жүктеп алу",
 "✅ Скопировано": "✅ Көшірілді",
 "📋 Копировать номер": "📋 Нөмірді көшіру",
 "Ошибка при загрузке счетов": "Шоттарды жүктеу кезінде қате шықты",
 "Неоплаченные счета": "Төленбеген шоттар",
 "Дата:": "Күні:",
 "Товаров:": "Тауарлар:",
 "тг": "тг",
 "Не оплачено": "Төленбеген",
 "Не оплачен": "Төленбеген",
 "Оплачен": "Төленген",
 "Отменён": "Күші жойылды",
 "Бонусы": "Бонустар",
 "Баланс бонусов": "Бонус балансы",
 "У вас 1200 бонусов. Используйте их при оформлении заказа.": "Сізде 1200 бонус бар. Тапсырыс беру кезінде пайдаланыңыз.",
 "Контакты": "Байланыс",
 "Загрузка контактов...": "Байланыстар жүктелуде...",
 "Свяжитесь с нами": "Бізбен байланысыңыз",
 "Ваш филиал: {{v0}}. ": "Сіздің филиалыңыз: {{v0}}. ",
 "Выберите удобный для вас способ связи": "Өзіңізге ыңғайлы байланыс тәсілін таңдаңыз",
 "Телефон": "Телефон",
 "Позвонить": "Қоңырау шалу",
 "Напишите нам": "Бізге жазыңыз",
 "Написать": "Жазу",
 "Наш канал": "Біздің арна",
 "Перейти": "Өту",
 "Следить": "Бақылау",
 "Контакты не доступны в данный момент": "Байланыс деректері қазір қолжетімсіз",
 "Филиалы": "Филиалдар",
 "Наши филиалы": "Біздің филиалдар",
 "Владелец:": "Иесі:",
 "Филиалы не найдены": "Филиалдар табылмады",
 "Мои счета": "Менің шоттарым",
 "Не удалось загрузить счета": "Шоттарды жүктеу мүмкін болмады",
 "Счетов пока нет": "Әзірге шоттар жоқ",
 "Счёт": "Шот",
 "Количество:": "Саны:",
 "Оплатить": "Төлеу",
 "Отслеживание груза": "Жүкті бақылау",
 "Реал-тайм информация о статусе посылки": "Сәлемдеме мәртебесі туралы нақты уақыттағы ақпарат",
 "Консультация по расчету": "Есептеу бойынша кеңес",
 "Помощь с расчетом стоимости доставки": "Жеткізу құнын есептеуге көмек",
 "Оформление документов": "Құжаттарды рәсімдеу",
 "Помощь в оформлении таможенных документов": "Кедендік құжаттарды рәсімдеуге көмек",
 "Логистические решения": "Логистикалық шешімдер",
 "Индивидуальные предложения для крупных грузов": "Ірі жүктерге жеке ұсыныстар",
 "Сколько времени занимает доставка?": "Жеткізу қанша уақыт алады?",
 "Срок доставки товаров из Китая в Казахстан составляет 8–15 дней. Счёт дней начинается с момента отправки товара со склада в Китае. В случае форс-мажора, праздников или работы таможни, сроки доставки могут измениться. Карго не несёт ответственность за задержки, вызванные указанными обстоятельствами.": "Қытайдан Қазақстанға тауарды жеткізу мерзімі — 8–15 күн. Күндер Қытайдағы қоймадан жөнелтілген сәттен бастап есептеледі. Форс-мажор, мерекелер немесе кеден жұмысы кезінде жеткізу мерзімі өзгеруі мүмкін. Аталған жағдайлардан туындаған кешігулер үшін карго жауап бермейді.",
 "Как работает страхование груза?": "Жүкті сақтандыру қалай жұмыс істейді?",
 "Клиент может оформить страховку при отправке через Карго. Стоимость страховки: 1% от стоимости груза (минимум 2 500 ₸). Страховка покрывает только заявленную стоимость товара по скриншоту. Если груз не застрахован, Карго не несёт ответственности за повреждение, потерю или недостачу. Отказаться от страховки можно только до отправки груза со склада.": "Клиент Карго арқылы жөнелту кезінде сақтандыруды рәсімдей алады. Сақтандыру құны — жүк құнының 1% (кемінде 2 500 ₸). Сақтандыру тек скриншот бойынша жарияланған тауар құнын жабады. Жүк сақтандырылмаса, зақымдану, жоғалу немесе кему үшін Карго жауап бермейді. Сақтандырудан тек жүк қоймадан жөнелтілгенге дейін бас тартуға болады.",
 "Какие документы требуются?": "Қандай құжаттар қажет?",
 "Требуется паспорт и таможенный декларат. Наш менеджер поможет вам с оформлением всех необходимых документов. Для хрупких товаров требуется деревянная обрешётка (стоимость 10 USD). Клиент обязан заранее уведомить карго о хрупком товаре.": "Паспорт және кедендік декларация қажет. Менеджеріміз барлық қажетті құжаттарды рәсімдеуге көмектеседі. Сынғыш тауарларға ағаш жәшік қажет (құны 10 USD). Клиент сынғыш тауар туралы карго компаниясына алдын ала хабарлауға міндетті.",
 "Какова ответственность компании?": "Компанияның жауапкершілігі қандай?",
 "Компания отвечает только за товары, которые поступили на склад и отображены на сайте. Ответственность за сохранность груза несёт только филиал Карго, который принял товар. Если товар забирает третье лицо по доверенности, все риски переходят на клиента. Компания не несёт ответственность за содержимое посылок и претензии к интернет-магазинам.": "Компания тек қоймаға келіп, сайтта көрсетілген тауарлар үшін жауап береді. Жүктің сақталуына тауарды қабылдаған Карго филиалы ғана жауап береді. Тауарды үшінші тұлға сенімхат бойынша алса, барлық тәуекелдер клиентке өтеді. Компания сәлемдеме құрамы және интернет-дүкендерге қатысты наразылықтар үшін жауап бермейді.",
 "Можно ли отменить или вернуть заказ?": "Тапсырысты бас тартуға немесе қайтаруға бола ма?",
 "Отмена возможна только до выкупа товара у продавца. После выкупа, поступления на склад или отправки в Казахстан отмена и возврат денежных средств категорически невозможны. По прибытию товара в Казахстан отказ от товара не допускается ни при каких обстоятельствах.": "Бас тарту тауар сатушыдан сатып алынғанға дейін ғана мүмкін. Сатып алынғаннан, қоймаға түскеннен немесе Қазақстанға жөнелтілгеннен кейін бас тарту және ақшаны қайтару мүлдем мүмкін емес. Тауар Қазақстанға келгеннен кейін одан бас тартуға ешбір жағдайда рұқсат етілмейді.",
 "Как защищена моя личная информация?": "Менің жеке ақпаратым қалай қорғалған?",
 "Карго обеспечивает сохранность всей личной информации клиента. Карго не раскрывает личные данные третьим лицам, за исключением случаев, необходимых для исполнения обязательств по доставке товара. Карго не раскрывает содержимое заказов и не ведёт учёт количества товаров.": "Карго клиенттің барлық жеке ақпаратының сақталуын қамтамасыз етеді. Карго жеке деректерді үшінші тұлғаларға, тауарды жеткізу міндеттемелерін орындау үшін қажет жағдайлардан басқа, жарияламайды. Карго тапсырыстардың мазмұнын жарияламайды және тауар санының есебін жүргізбейді.",
 "Менеджер": "Менеджер",
 "Услуги менеджера": "Менеджер қызметтері",
 "❓ Часто задаваемые вопросы": "❓ Жиі қойылатын сұрақтар",
 "⏰ График работы менеджера": "⏰ Менеджердің жұмыс кестесі",
 "📞 Телефон / WhatsApp:": "📞 Телефон / WhatsApp:",
 "Понедельник": "Дүйсенбі",
 "Выходной": "Демалыс",
 "Вторник–Пятница": "Сейсенбі–Жұма",
 "Суббота–Воскресенье": "Сенбі–Жексенбі",
 "Скачать оферту (файл)": "Оферта файлын жүктеп алу",
 "← Вернуться на главную": "← Басты бетке оралу",
 "Требуется авторизация для доступа к QR функциям": "QR функцияларына кіру үшін авторизация қажет",
 "Настройки": "Параметрлер",
 "Условия (файл):": "Шарттар (файл):",
 "Открыть": "Ашу",
 "не загружен": "жүктелмеген",
 "Адрес склада (chinaAddress):": "Қойма мекенжайы (chinaAddress):",
 "не указан": "көрсетілмеген",
 "Номер WhatsApp менеджера:": "Менеджердің WhatsApp нөмірі:",
 "Настройки не заданы": "Параметрлер берілмеген",
 "Условия": "Шарттар",
 "Условия использования": "Пайдалану шарттары",
 "Ознакомьтесь с информацией о нашем сервисе": "Біздің сервис туралы ақпаратпен танысыңыз",
 "📺 Инструкция": "📺 Нұсқаулық",
 "Посмотреть видеоинструкцию →": "Бейне нұсқаулықты қарау →",
 "💬 Связь с нами": "💬 Бізбен байланыс",
 "Написать в WhatsApp →": "WhatsApp-қа жазу →",
 "ℹ️ О нас": "ℹ️ Біз туралы",
 "⛔ Товары которые нельзя заказывать": "⛔ Тапсырыс беруге болмайтын тауарлар",
 "📍 Адрес китайского склада": "📍 Қытай қоймасының мекенжайы",
 "📄 Документы": "📄 Құжаттар",
 "Скачать договор и условия": "Шарт пен ережелерді жүктеп алу",
 "❓ Остались вопросы? Свяжитесь с нашей поддержкой": "❓ Сұрақтарыңыз қалды ма? Қолдау қызметімен байланысыңыз",
 "Адрес склада 291cargo": "291cargo қоймасының мекенжайы",
 "Склад": "Қойма",
 "Загрузка информации о складе...": "Қойма туралы ақпарат жүктелуде...",
 "Наш склад в Китае": "Қытайдағы біздің қойма",
 "Отправьте посылку на этот адрес для дальнейшей доставки в Казахстан": "Қазақстанға әрі қарай жеткізу үшін сәлемдемені осы мекенжайға жіберіңіз",
 "Адрес склада": "Қойма мекенжайы",
 "Адрес не задан": "Мекенжай берілмеген",
 "✓ Скопировано": "✓ Көшірілді",
 "📋 Скопировать": "📋 Көшіру",
 "🔗 Поделиться": "🔗 Бөлісу",
 "Как отправить посылку?": "Сәлемдемені қалай жіберу керек?",
 "Скопируйте адрес": "Мекенжайды көшіріңіз",
 "Нажмите кнопку \"Скопировать\" и скопируйте полный адрес нашего склада": "\"Көшіру\" батырмасын басып, қоймамыздың толық мекенжайын көшіріңіз",
 "Оформите доставку": "Жеткізуді рәсімдеңіз",
 "Оформите доставку через местную логистическую компанию или доставку лично": "Жергілікті логистикалық компания арқылы немесе өзіңіз жеткізіңіз",
 "Получите трек-номер": "Трек-нөмірді алыңыз",
 "Отправьте нам номер отслеживания через чат с менеджером": "Бақылау нөмірін менеджермен чат арқылы жіберіңіз",
 "Отслеживайте груз": "Жүкті бақылаңыз",
 "Смотрите статус доставки в своем личном кабинете в разделе \"Посылки\"": "Жеткізу мәртебесін жеке кабинетіңіздегі \"Сәлемдемелер\" бөлімінен қараңыз",
 "💡 Полезные советы": "💡 Пайдалы кеңестер",
 "✓ Убедитесь, что посылка хорошо упакована": "✓ Сәлемдеме жақсы оралғанына көз жеткізіңіз",
 "✓ Указывайте правильные размеры и вес": "✓ Дұрыс өлшемдер мен салмақты көрсетіңіз",
 "✓ Проверьте список запрещенного содержимого": "✓ Тыйым салынған құрамның тізімін тексеріңіз",
 "✓ Сохраняйте чеки и документы доставки": "✓ Чектер мен жеткізу құжаттарын сақтаңыз",
 "✓ Уведомляйте нас как можно раньше о отправке": "✓ Жөнелту туралы бізге мүмкіндігінше ерте хабарлаңыз",
 "Вопросы по адресу складу? Свяжитесь с нашей поддержкой через менеджера": "Қойма мекенжайы бойынша сұрақтар бар ма? Менеджер арқылы қолдау қызметімен байланысыңыз",
 "💬 Написать менеджеру": "💬 Менеджерге жазу",
 "Сообщения клиентам": "Клиенттерге хабарламалар",
 "Все клиенты": "Барлық клиенттер",
 "Филиал: {{v0}}": "Филиал: {{v0}}",
 "Выбранные клиенты ({{v0}})": "Таңдалған клиенттер ({{v0}})",
 "Выбранные клиенты": "Таңдалған клиенттер",
 "Не удалось загрузить данные": "Деректерді жүктеу мүмкін болмады",
 "выбранным клиентам: {{v0}}": "таңдалған клиенттерге: {{v0}}",
 "всем клиентам филиала «{{v0}}»: {{v1}}": "«{{v0}}» филиалының барлық клиенттеріне: {{v1}}",
 "всем клиентам: {{v0}}": "барлық клиенттерге: {{v0}}",
 "Отправить сообщение {{v0}}? Оно придёт на сайт, в push и в Telegram. Отменить отправку нельзя.": "Хабарламаны жіберу {{v0}}? Ол сайтқа, push және Telegram арқылы келеді. Жіберуді болдырмау мүмкін емес.",
 "Отправить": "Жіберу",
 "Отправлено клиентам: {{v0}} (push: {{v1}}, Telegram: {{v2}})": "Клиенттерге жіберілді: {{v0}} (push: {{v1}}, Telegram: {{v2}})",
 "пропущено: {{v0}}": "өткізілді: {{v0}}",
 "Не удалось отправить сообщение": "Хабарламаны жіберу мүмкін болмады",
 "Сообщение появится в уведомлениях на сайте, придёт push и в Telegram (если клиент привязал бота).": "Хабарлама сайттағы хабарландыруларда пайда болады, push және Telegram арқылы келеді (клиент ботты байланыстырса).",
 "Кому": "Кімге",
 "Всем клиентам филиала": "Филиалдың барлық клиенттеріне",
 "Всем клиентам": "Барлық клиенттерге",
 "Выберите филиал": "Филиалды таңдаңыз",
 "Ваш филиал: {{v0}}. Писать можно только клиентам своего филиала.": "Сіздің филиалыңыз: {{v0}}. Тек өз филиалыңыздың клиенттеріне жаза аласыз.",
 "Поиск клиента: имя, телефон, ID...": "Клиентті іздеу: аты, телефон, ID...",
 "Клиенты не найдены": "Клиенттер табылмады",
 "Выбрать всех найденных": "Табылғандардың бәрін таңдау",
 "Очистить": "Тазалау",
 "Клиентов: {{v0}} · push-подписок у клиентов: {{v1}} · в Telegram: {{v2}}": "Клиенттер: {{v0}} · push жазылымы барлар: {{v1}} · Telegram-да: {{v2}}",
 "Сообщение": "Хабарлама",
 "Заголовок": "Тақырып",
 "Например: Ваша посылка прибыла": "Мысалы: Сіздің сәлемдемеңіз келді",
 "Текст": "Мәтін",
 "Выберите хотя бы одного клиента": "Кемінде бір клиентті таңдаңыз",
 "Последние рассылки": "Соңғы жіберілімдер",
 "Пока ничего не отправлялось": "Әзірге ештеңе жіберілген жоқ",
 "Отправитель": "Жіберуші",
 "Получили": "Алғандар",
 "Вес посылки, г": "Сәлемдеме салмағы, г",
 "Изменить трек": "Трек нөмірін өзгерту",
 "Итого за день": "Күн бойынша барлығы",
 "Ищу посылку…": "Сәлемдеме ізделуде…",
 "Некорректный трек-номер": "Трек нөмірі қате",
 "Новый вес для {{v0}}, г": "{{v0}} үшін жаңа салмақ, г",
 "Общий вес, г": "Жалпы салмақ, г",
 "Оставить": "Қалдыру",
 "Открывать камеру после каждой записи": "Әр жазбадан кейін камераны ашу",
 "Отсканируйте или введите трек": "Трек нөмірін сканерлеңіз немесе енгізіңіз",
 "Посылка {{v0}} уже принималась {{v1}} ({{v2}}, {{v3}}). Принять ещё раз?": "{{v0}} сәлемдемесі {{v1}} күні қабылданған ({{v2}}, {{v3}}). Қайта қабылдау керек пе?",
 "Принять ещё раз": "Қайта қабылдау",
 "Приход за": "Келгені:",
 "Сканировать камерой": "Камерамен сканерлеу",
 "Сумма к оплате": "Төленетін сома",
 "Трек-номер": "Трек нөмірі",
 "Трек-номер посылки ({{v0}}, {{v1}})": "Сәлемдеме трек нөмірі ({{v0}}, {{v1}})",
 "Укажите вес в граммах целым числом, например 268": "Салмақты граммен бүтін санмен енгізіңіз, мысалы 268",
 "Эта посылка уже принималась {{v0}} ({{v1}}, {{v2}})": "Бұл сәлемдеме {{v0}} күні қабылданған ({{v1}}, {{v2}})",
 "Эта посылка уже принималась {{v0}} ({{v1}}, {{v2}}). Проверьте, не дубль ли это.": "Бұл сәлемдеме {{v0}} күні қабылданған ({{v1}}, {{v2}}). Қайталану емес пе, тексеріңіз.",
 "Этот трек уже принимался. Оставить всё равно?": "Бұл трек бұрын қабылданған. Бәрібір қалдыру керек пе?",
 "без трека": "трексіз",
 "клиентов": "клиент",
 "общий вес, г": "жалпы салмақ, г",
 "посылок: {{v0}}": "сәлемдемелер: {{v0}}",
 "сумма к оплате": "төленетін сома",
 "Весь город": "Бүкіл қала",
 "всем клиентам города: {{v0}}": "қаланың барлық клиенттеріне: {{v0}}",
 "Всем клиентам города": "Қаланың барлық клиенттеріне",
 "Все филиалы города": "Қаладағы барлық филиалдар",
 "Ваш город: филиалы {{v0}}. Писать можно клиентам этих филиалов.": "Сіздің қалаңыз: {{v0}} филиалдары. Осы филиалдардың клиенттеріне жаза аласыз.",
 "Город (необязательно): филиалы одного города работают с клиентами друг друга": "Қала (міндетті емес): бір қаладағы филиалдар бір-бірінің клиенттерімен жұмыс істейді",
 "Город:": "Қала:",
 "Выбранным клиентам": "Таңдалған клиенттерге",
 "Калькулятор": "Калькулятор",
 "Сколько стоит доставка": "Жеткізу қанша тұрады",
 "Не удалось загрузить тариф. Попробуйте позже.": "Тарифті жүктеу мүмкін болмады. Кейінірек қайталап көріңіз.",
 "Тариф пока не задан. Уточните стоимость у менеджера филиала.": "Тариф әлі белгіленбеген. Бағасын филиал менеджерінен нақтылаңыз.",
 "Ваш тариф: {{v0}} за кг": "Сіздің тарифіңіз: кг үшін {{v0}}",
 "ваш личный тариф": "сіздің жеке тарифіңіз",
 "тариф вашего филиала": "сіздің филиалыңыздың тарифі",
 "общий тариф": "жалпы тариф",
 "Вес посылки": "Сәлемдеме салмағы",
 "Единицы веса": "Салмақ бірліктері",
 "г": "г",
 "Количество одинаковых посылок": "Бірдей сәлемдемелер саны",
 "Общий вес: {{v0}} г": "Жалпы салмақ: {{v0}} г",
 "Введите вес, чтобы увидеть стоимость": "Бағасын көру үшін салмақты енгізіңіз",
 "Расчёт примерный: итог определяется по весу посылки на складе.": "Есептеу шамамен: түпкілікті баға қоймадағы сәлемдеме салмағымен анықталады.",
 "Размеры посылки, см (необязательно)": "Сәлемдеме өлшемдері, см (міндетті емес)",
 "Длина, см": "Ұзындығы, см",
 "Ширина, см": "Ені, см",
 "Высота, см": "Биіктігі, см",
 "Д": "Ұ",
 "Ш": "Е",
 "В": "Б",
 "Объёмный вес = Д × Ш × В / {{v0}}. Оплачивается большее из фактического и объёмного веса.": "Көлемдік салмақ = Ұ × Е × Б / {{v0}}. Нақты және көлемдік салмақтың үлкені төленеді.",
 "Расчётный вес: {{v0}} г": "Есептік салмақ: {{v0}} г",
 "фактический: {{v0}} г": "нақты: {{v0}} г",
 "объёмный: {{v0}} г": "көлемдік: {{v0}} г",
 "Объёмный вес больше фактического — стоимость считается по нему.": "Көлемдік салмақ нақтыдан үлкен, сондықтан баға соған байланысты есептеледі.",
 "Введите вес или размеры, чтобы увидеть стоимость": "Бағасын көру үшін салмақты немесе өлшемдерді енгізіңіз",
 "Коэффициент должен быть целым числом от 1000 до 20000, например 5000": "Коэффициент 1000-нан 20000-ға дейінгі бүтін сан болуы керек, мысалы 5000",
 "Коэффициент объёмного веса сохранён": "Көлемдік салмақ коэффициенті сақталды",
 "Коэффициент объёмного веса": "Көлемдік салмақ коэффициенті",
 "Д×Ш×В (см) / коэффициент = объёмный вес, кг. Показывается в калькуляторе клиентов": "Ұ×Е×Б (см) / коэффициент = көлемдік салмақ, кг. Клиенттердің калькуляторында қолданылады",
 "Отчёты": "Есептер",
 "Должники": "Борышкерлер",
 "Не удалось загрузить должников": "Борышкерлерді жүктеу мүмкін болмады",
 "Не удалось загрузить сводку": "Жиынтықты жүктеу мүмкін болмады",
 "Не удалось выгрузить файл": "Файлды жүктеп алу мүмкін болмады",
 "Отправить {{v0}} напоминание об оплате ({{v1}})? Придёт на сайт, в push и в Telegram.": "{{v0}} клиентіне төлем туралы еске салу жіберілсін бе ({{v1}})? Сайтқа, push және Telegram арқылы келеді.",
 "Напомнить": "Еске салу",
 "Напоминание отправлено": "Еске салу жіберілді",
 "Не удалось отправить напоминание": "Еске салуды жіберу мүмкін болмады",
 "Давность долга": "Қарыз мерзімі",
 "Любая давность": "Кез келген мерзім",
 "Старше 7 дней": "7 күннен ескі",
 "Старше 14 дней": "14 күннен ескі",
 "Старше 30 дней": "30 күннен ескі",
 "Скачать CSV": "CSV жүктеп алу",
 "Должников нет": "Борышкерлер жоқ",
 "Счетов": "Шоттар",
 "Дней": "Күн",
 "Итого: должников {{v0}}": "Барлығы: {{v0}} борышкер",
 "Показаны первые 1000 должников.": "Алғашқы 1000 борышкер көрсетілген.",
 "Приход и оплаты по дням": "Күн бойынша келу және төлемдер",
 "С даты": "Басталуы",
 "По дату": "Аяқталуы",
 "За этот период ничего не было": "Бұл кезеңде ештеңе болмады",
 "Посылок": "Сәлемдемелер",
 "Вес, г": "Салмағы, г",
 "Выставлено": "Шот қойылды",
 "Итого": "Барлығы",
 "Журнал действий": "Әрекеттер журналы",
 "Журнал": "Журнал",
 "Тип действий": "Әрекет түрі",
 "Все действия": "Барлық әрекеттер",
 "Клиенты": "Клиенттер",
 "Тарифы": "Тарифтер",
 "Рассылки": "Хабарламалар",
 "Входы": "Кірулер",
 "админ": "әкімші",
 "филиал": "филиал",
 "клиент": "клиент",
 "Поиск: сотрудник или клиент": "Іздеу: қызметкер немесе клиент",
 "Записей нет": "Жазбалар жоқ",
 "Кто": "Кім",
 "Что сделал": "Не істеді",
 "Над чем": "Нысан",
 "Подробности": "Толығырақ",
 "Страница {{v0}} из {{v1}}": "{{v1}} беттің {{v0}}-беті",
 "записей: {{v0}}": "жазба: {{v0}}",
 "Не удалось загрузить журнал": "Журналды жүктеу мүмкін болмады",
 "Вход в систему": "Жүйеге кіру",
 "Приёмка: добавлена посылка": "Қабылдау: сәлемдеме қосылды",
 "Приёмка: изменена запись": "Қабылдау: жазба өзгертілді",
 "Приёмка: удалена запись": "Қабылдау: жазба жойылды",
 "Приёмка: выставлены счета": "Қабылдау: шоттар қойылды",
 "Счёт выставлен": "Шот қойылды",
 "Счёт изменён": "Шот өзгертілді",
 "Счёт отмечен оплаченным": "Шот төленді деп белгіленді",
 "Клиент: данные изменены": "Клиент: деректер өзгертілді",
 "Клиент удалён": "Клиент жойылды",
 "Личный тариф клиента": "Клиенттің жеке тарифі",
 "Процент бонуса клиента": "Клиенттің бонус пайызы",
 "Бонусы начислены": "Бонустар есептелді",
 "Бонусы списаны": "Бонустар есептен шығарылды",
 "Филиал добавлен": "Филиал қосылды",
 "Филиал изменён": "Филиал өзгертілді",
 "Филиал удалён": "Филиал жойылды",
 "Реквизиты филиала": "Филиал деректемелері",
 "Тариф филиала": "Филиал тарифі",
 "Настройки изменены": "Баптаулар өзгертілді",
 "Общий процент бонуса": "Жалпы бонус пайызы",
 "Рассылка клиентам": "Клиенттерге хабарлама",
 "Сверка оплат с отчётом Kaspi": "Kaspi есебімен төлемдерді салыстыру",
 "Загрузить PDF-отчёт": "PDF есепті жүктеу",
 "PDF-отчёт Kaspi": "Kaspi PDF есебі",
 "Загрузите ежедневный «Отчёт по продажам» из Kaspi Pay. В нём есть время и сумма, но нет имён, поэтому счета ищутся по сумме. Файл читается в вашем браузере.": "Kaspi Pay-дағы күнделікті «Сатылымдар есебін» жүктеңіз. Онда уақыт пен сома бар, бірақ аттар жоқ, сондықтан шоттар сома бойынша табылады. Файл браузеріңізде оқылады.",
 "Или вставьте текст отчёта": "Немесе есеп мәтінін қойыңыз",
 "Текст отчёта": "Есеп мәтіні",
 "Разобрать текст": "Мәтінді талдау",
 "Не удалось разобрать отчёт": "Есепті талдау мүмкін болмады",
 "Не удалось прочитать PDF": "PDF оқу мүмкін болмады",
 "продаж: {{v0}} на {{v1}}": "сатылым: {{v0}}, сомасы {{v1}}",
 "однозначных: {{v0}}": "нақты сәйкестік: {{v0}}",
 "спорных: {{v0}}": "даулы: {{v0}}",
 "без счёта: {{v0}}": "шотсыз: {{v0}}",
 "уже обработано: {{v0}}": "өңделген: {{v0}}",
 "Отметить оплату {{v0}}": "{{v0}} төлемін белгілеу",
 "Выбор счёта {{v0}}": "{{v0}} үшін шотты таңдау",
 "— выберите счёт —": "— шотты таңдаңыз —",
 "нет неоплаченного счёта на эту сумму": "бұл сомаға төленбеген шот жоқ",
 "пропущена": "өткізілді",
 "обработана: {{v0}}": "өңделді: {{v0}}",
 "Пропустить": "Өткізу",
 "Отметить оплаченными счета: {{v0}} на сумму {{v1}}? Клиенты получат уведомление.": "{{v0}} шот {{v1}} сомасына төленді деп белгіленсін бе? Клиенттерге хабарландыру барады.",
 "Отметить": "Белгілеу",
 "Отмечено оплаченными: {{v0}}": "Төленді деп белгіленді: {{v0}}",
 "не отмечено: {{v0}} ({{v1}})": "белгіленбеді: {{v0}} ({{v1}})",
 "Не удалось отметить оплаты": "Төлемдерді белгілеу мүмкін болмады",
 "Пропустить продажу {{v0}} на {{v1}}? Она больше не будет предлагаться.": "{{v0}} сатылымын ({{v1}}) өткізу керек пе? Ол енді ұсынылмайды.",
 "Не удалось пропустить": "Өткізу мүмкін болмады",
 "Отметить выбранные оплаченными ({{v0}})": "Таңдалғандарды төленді деп белгілеу ({{v0}})",
 "уже обработана": "өңделген",
 "счёт уже не ожидает оплаты": "шот енді төлемді күтпейді",
 "сумма не совпала": "сома сәйкес келмеді",
 "нет доступа к клиенту": "клиентке қолжетімділік жоқ",
 "счёт не найден": "шот табылмады",
 "некорректные данные": "деректер қате",
 "ошибка": "қате",
 "Загрузка отправок из файла": "Файлдан жөнелтімдерді жүктеу",
 "Оплата Kaspi пропущена": "Kaspi төлемі өткізілді",
 "Отправки": "Жөнелтімдер",
 "Оплаты Kaspi": "Kaspi төлемдері",
 "Режим": "Режим",
 "Отправлен": "Жөнелтілді",
 "Прибыл": "Келді",
 "Код": "Код",
 "Всего": "Барлығы",
 "Создано": "Құрылды",
 "Обновлено": "Жаңартылды",
 "Уже было": "Бұрыннан бар",
 "Дальше по статусу": "Статус алда",
 "Другая дата": "Басқа күн",
 "Оплатить онлайн": "Онлайн төлеу",
 "Карта, Apple Pay, Google Pay": "Карта, Apple Pay, Google Pay",
 "Не удалось создать платёж. Попробуйте позже.": "Төлемді жасау мүмкін болмады. Кейінірек қайталап көріңіз.",
 "Спасибо! Оплата принята, статус счёта обновится в течение минуты.": "Рахмет! Төлем қабылданды, шот күйі бір минут ішінде жаңарады.",
 "Оплата не прошла. Попробуйте ещё раз.": "Төлем өтпеді. Қайталап көріңіз.",
 "Тестовая оплата получена (счёт в тестовом режиме не закрывается).": "Сынақ төлемі алынды (сынақ режимінде шот жабылмайды).",
 "Оплата получена, но счёт закрыть не удалось. Свяжитесь с филиалом, мы всё проверим.": "Төлем алынды, бірақ шотты жабу мүмкін болмады. Филиалмен байланысыңыз, біз тексереміз.",
 "Активность клиентов": "Клиенттер белсенділігі",
 "Заходили сегодня": "Бүгін кірді",
 "за 7 дней": "7 күнде",
 "за 30 дней": "30 күнде",
 "всего клиентов": "барлық клиент",
 "Отметки о заходах копятся с момента включения функции.": "Кіру белгілері функция қосылған сәттен бастап жиналады.",
 "Кто заходил сегодня": "Бүгін кімдер кірді",
 "Скрыть список": "Тізімді жасыру",
 "Последний визит": "Соңғы кіру",
 "вчера": "кеше",
 "Счёт (ID)": "Шот (ID)",
 "Источник": "Дереккөз",
 "Заказ": "Тапсырыс",
 "Пропущено": "Өткізілді",
 "Поля": "Өрістер",
 "Получателей": "Алушылар",
 "Город": "Қала",
 "Телефон владельца": "Иесінің телефоны",
 "Владелец (ID)": "Иесі (ID)",
 "Цена": "Бағасы",
 "Валюта": "Валюта",
 "Личный тариф": "Жеке тариф",
 "Процент бонуса": "Бонус пайызы",
 "Коэффициент": "Коэффициент",
 "Код клиента": "Клиент коды",
 "Пароль изменён": "Құпиясөз өзгертілді",
 "Ссылка оплаты изменена": "Төлем сілтемесі өзгертілді",
 "да": "иә",
 "онлайн-оплата Freedom Pay": "Freedom Pay онлайн төлемі",
 "онлайн-оплата Freedom Pay (тест)": "Freedom Pay онлайн төлемі (сынақ)",
 "онлайн-оплата: не засчитана": "онлайн төлем: есепке алынбады",
 "отчёт Kaspi": "Kaspi есебі",
 "вручную": "қолмен",
 "таблица": "кесте",
 "приёмка": "қабылдау",
 "Документы": "Құжаттар",
 "Политика конфиденциальности": "Құпиялылық саясаты",
 "Возврат средств": "Қаражатты қайтару",
 "ИИН": "ЖСН",
 "Тел.:": "Тел.:",
 "Режим работы": "Жұмыс уақыты",
 "выдача посылок": "сәлемдемелерді беру",
 "Выдача посылок": "Сәлемдемелерді беру",
 "с 9:00 до 20:00": "9:00-ден 20:00-ге дейін",
 "круглосуточно": "тәулік бойы",
 "Оплата банковскими картами Visa и Mastercard, Apple Pay и Google Pay через платёжный шлюз Freedom Pay. Мы не храним данные банковских карт.": "Visa және Mastercard карталарымен, Apple Pay және Google Pay арқылы Freedom Pay төлем шлюзі арқылы төлем. Біз банк карталарының деректерін сақтамаймыз.",
 "На главную": "Басты бетке",
 "Адрес": "Мекенжай",
 "Реквизиты": "Деректемелер",
 "Реквизиты исполнителя": "Орындаушы деректемелері",
 "Торговая марка": "Сауда белгісі",
 "Другие города": "Басқа қалалар",
 "Темиртау": "Теміртау",
 "Астана": "Астана",
 "Принимаем к оплате": "Төлемге қабылдаймыз",
 "Запрещённые товары": "Тыйым салынған тауарлар",
 "⛔ Запрещённые и хрупкие товары": "⛔ Тыйым салынған және сынғыш тауарлар",
 "Открыть полный список →": "Толық тізімді ашу →",
 "🎬 Видеоинструкции": "🎬 Бейнеөсиеттер",
 "Видеоинструкции": "Бейнеөсиеттер",
 "Не удалось загрузить видеоинструкции": "Бейнеөсиеттерді жүктеу мүмкін болмады",
 "Сохранено": "Сақталды",
 "Название и ссылка (например, на YouTube). Показываются клиентам в боте (/video) и на странице «Условия».": "Атауы мен сілтеме (мысалы, YouTube). Клиенттерге ботта (/video) және «Шарттар» бетінде көрсетіледі.",
 "Название": "Атауы",
 "Ссылка": "Сілтеме",
 "+ Добавить видео": "+ Бейне қосу",
 "Сохранить видеоинструкции": "Бейнеөсиеттерді сақтау",
 "📲 Подключите Telegram": "📲 Telegram-ды қосыңыз",
 "Уведомления о посылках и счетах, список посылок и добавление треков прямо в чате.": "Сәлемдемелер мен шоттар туралы хабарландырулар, сәлемдемелер тізімі және тректерді чатта тікелей қосу.",
 "Подключить": "Қосу",
 "Позже": "Кейінірек",
 "Коды клиентов": "Клиент кодтары",
 "Не удалось загрузить коды клиентов": "Клиент кодтарын жүктеу мүмкін болмады",
 "Не удалось выдать код": "Кодты беру мүмкін болмады",
 "Сообщение скопировано": "Хабарлама көшірілді",
 "Не удалось скопировать": "Көшіру мүмкін болмады",
 "Выдайте клиенту код и номер телефона: зарегистрироваться можно только по этой паре. Отправьте код клиенту в личном сообщении (WhatsApp или Telegram).": "Клиентке код пен телефон нөмірін беріңіз: тек осы жұппен тіркелуге болады. Кодты клиентке жеке хабарламамен (WhatsApp немесе Telegram) жіберіңіз.",
 "Номер телефона клиента": "Клиенттің телефон нөмірі",
 "Код клиента (латиницей)": "Клиент коды (латын әрпімен)",
 "Выдать код": "Код беру",
 "Код выдан": "Код берілді",
 "Скопировать сообщение клиенту": "Хабарламаны клиентке көшіру",
 "Выданные коды": "Берілген кодтар",
 "Кодов пока нет": "Әзірге кодтар жоқ",
 "Выдал": "Берген",
 "Скопировать": "Көшіру",
 "Ожидает регистрации": "Тіркелуді күтуде",
 "Зарегистрирован": "Тіркелген",
 "Срок истёк": "Мерзімі өтті",
 "Адрес для этого филиала не задан: заполните его в «Мой карго» → Настройки филиала": "Бұл филиал үшін мекенжай көрсетілмеген: оны «Менің карго» → филиал параметрлерінде толтырыңыз",
 "Адрес пока не задан, уточните его у менеджера": "Мекенжай әлі көрсетілмеген, менеджерден сұраңыз",
 "Как адрес выглядит в приложении": "Мекенжай қолданбада қалай көрінеді",
 "В приложении китайского маркетплейса добавьте адрес склада и в конце «Детального адреса» впишите свой код клиента (на примере он показан как «КОД КЛИЕНТА»). Адрес на примере для Темиртау; для вашего филиала скопируйте адрес выше.": "Қытай маркетплейсінің қолданбасында қойма мекенжайын қосып, «Толық мекенжайдың» соңына клиент кодыңызды жазыңыз (мысалда «КОД КЛИЕНТА» ретінде көрсетілген). Мысал Теміртау үшін; өз филиалыңыз үшін жоғарыдағы мекенжайды көшіріңіз.",
 "Заполнение адреса: в конце детального адреса стоит код клиента": "Мекенжайды толтыру: толық мекенжайдың соңында клиент коды тұр",
 "Сохранённый адрес с кодом клиента": "Клиент коды бар сақталған мекенжай",
 "1. Вставьте адрес и допишите в конце свой код клиента": "1. Мекенжайды қойып, соңына клиент кодыңызды жазыңыз",
 "2. Сохранённый адрес: код клиента стоит в конце": "2. Сақталған мекенжай: клиент коды соңында",
 "В приложении китайского маркетплейса добавьте адрес склада и в конце «Детального адреса» впишите свой код клиента.": "Қытай маркетплейсінің қолданбасында қойма мекенжайын қосып, «Толық мекенжайдың» соңына клиент кодыңызды жазыңыз.",
 "Адрес вашего филиала в приложении": "Қолданбадағы филиалыңыздың мекенжайы",
 "в конце адреса стоит код клиента": "клиент коды мекенжайдың соңында тұрады",
 "Теперь это сотрудник филиала": "Енді бұл филиал қызметкері",
 "Возвращён в клиенты": "Клиенттерге қайтарылды",
 "Не удалось изменить роль": "Рөлді өзгерту мүмкін болмады",
 "сотрудник филиала": "филиал қызметкері",
 "Филиал сотрудника": "Қызметкер филиалы",
 "Сделать сотрудником филиала": "Филиал қызметкері ету",
 "Вернуть в клиенты": "Клиенттерге қайтару",
 "Забыли пароль?": "Құпия сөзді ұмыттыңыз ба?",
 "Через Telegram": "Telegram арқылы",
 "Бот пришлёт кнопку со ссылкой. Она действует 15 минут и сработает один раз: откройте её и задайте новый пароль.": "Бот сілтемесі бар батырма жібереді. Ол 15 минут жарамды және бір рет қана істейді: оны ашып, жаңа құпия сөз орнатыңыз.",
 "Открыть бот в Telegram": "Ботты Telegram-да ашу",
 "Без Telegram": "Telegram-сыз",
 "Обратитесь к представителю своего филиала: он отправит вам ссылку для смены пароля в личном сообщении.": "Филиалыңыздың өкіліне хабарласыңыз: ол сізге құпия сөзді ауыстыру сілтемесін жеке хабарламамен жібереді.",
 "← Вернуться ко входу": "← Кіруге оралу",
 "Новый пароль": "Жаңа құпия сөз",
 "Проверяем ссылку...": "Сілтемені тексеріп жатырмыз...",
 "Как восстановить пароль": "Құпия сөзді қалай қалпына келтіруге болады",
 "Пароли не совпадают": "Құпия сөздер сәйкес емес",
 "Не удалось сменить пароль": "Құпия сөзді ауыстыру мүмкін болмады",
 "Повторите пароль": "Құпия сөзді қайталаңыз",
 "Сменить пароль": "Құпия сөзді ауыстыру",
 "Пароль изменён. Теперь можно войти с новым паролем.": "Құпия сөз өзгертілді. Енді жаңа құпия сөзбен кіре аласыз.",
 "Отправить ссылку для смены пароля": "Құпия сөзді ауыстыру сілтемесін жіберу",
 "Не удалось создать ссылку": "Сілтеме жасау мүмкін болмады",
 "Ссылка отправлена клиенту в Telegram.": "Сілтеме клиентке Telegram-да жіберілді.",
 "У клиента не подключён Telegram: скопируйте сообщение и отправьте ему в WhatsApp.": "Клиентте Telegram қосылмаған: хабарламаны көшіріп, WhatsApp арқылы жіберіңіз.",
 "Ссылка действует 15 минут и сработает один раз.": "Сілтеме 15 минут жарамды және бір рет қана істейді.",
 "Нажмите кнопку «Открыть бот в Telegram» ниже и в Telegram нажмите «Старт». Если бот уже открыт, нажмите в его меню кнопку «🔑 Забыл пароль».": "Төмендегі «Ботты Telegram-да ашу» батырмасын басып, Telegram-да «Бастау» түймесін басыңыз. Бот ашық болса, мәзірдегі «🔑 Құпия сөзді ұмыттым» батырмасын басыңыз.",
 "Ссылка недействительна или устарела. Запросите новую: в боте нажмите «🔑 Забыл пароль» или попросите представителя филиала.": "Сілтеме жарамсыз немесе ескірген. Жаңасын сұраңыз: ботта «🔑 Құпия сөзді ұмыттым» батырмасын басыңыз немесе филиал өкілінен сұраңыз.",
 "Если бот ещё не подключён к вашему аккаунту, поделитесь контактом кнопкой в чате: так мы убеждаемся, что номер ваш.": "Бот аккаунтыңызбен әлі байланыспаған болса, чаттағы батырма арқылы байланыс деректеріңізбен бөлісіңіз: осылай нөмір сіздікі екеніне көз жеткіземіз.",
 "Заявки": "Өтінімдер",
 "Не удалось загрузить заявки": "Өтінімдерді жүктеу мүмкін болмады",
 "Заявки на обрешётку и инспекцию, которые клиенты отправили через Telegram-бота до поступления товара на склад. Новые заявки приходят и сообщением в Telegram представителю филиала.": "Клиенттер тауар қоймаға түспес бұрын Telegram-бот арқылы жіберген жәшіктеу және тексеру өтінімдері. Жаңа өтінімдер филиал өкіліне Telegram-хабарлама ретінде де келеді.",
 "Новых заявок": "Жаңа өтінімдер",
 "Только новые": "Тек жаңалары",
 "Заявок нет": "Өтінімдер жоқ",
 "Услуга": "Қызмет",
 "Обрешётка": "Жәшіктеу",
 "Инспекция": "Тексеру",
 "Обрешётка + инспекция": "Жәшіктеу + тексеру",
 "Новая": "Жаңа",
 "Выполнена": "Орындалды",
 "Отменена": "Бас тартылды",
 "Выполнено": "Орындалды",
 "Вернуть в новые": "Жаңаларға қайтару",
 "Привет! Закажи доставку из Китая в 291cargo. При регистрации укажи мой номер": "Сәлем! 291cargo арқылы Қытайдан жеткізуге тапсырыс бер. Тіркелгенде менің нөмірімді көрсет",
 "Приглашение скопировано": "Шақыру көшірілді",
 "Реферальная программа": "Рефералдық бағдарлама",
 "Сейчас программа недоступна для вашего филиала.": "Қазір бағдарлама сіздің филиалыңызға қолжетімсіз.",
 "Ваша скидка на вес": "Салмаққа жеңілдігіңіз",
 "Активных приглашённых": "Белсенді шақырылғандар",
 "У вас личный (VIP) тариф: реферальная скидка с ним не суммируется.": "Сізде жеке (VIP) тариф бар: рефералдық жеңілдік онымен қосылмайды.",
 "Скидка начисляется на плату за вес при выставлении счёта. Процент фиксируется в момент выставления счёта.": "Жеңілдік шот шығарылғанда салмақ төлемінен есептеледі. Пайыз шот шығарылған сәтте бекітіледі.",
 "Как это работает": "Бұл қалай жұмыс істейді",
 "Дайте новому клиенту свой номер телефона": "Жаңа клиентке өз телефон нөміріңізді беріңіз",
 "При регистрации он вводит ваш номер в поле «Номер пригласившего».": "Тіркелгенде ол сіздің нөміріңізді «Шақырған клиенттің нөмірі» өрісіне енгізеді.",
 "Каждый приглашённый, у которого за последние {{v0}} дн. не меньше {{v1}} посылок на складе, даёт вам {{v2}}% скидки (максимум {{v3}}%).": "Соңғы {{v0}} күнде қоймада кемінде {{v1}} сәлемдемесі бар әрбір шақырылған сізге {{v2}}% жеңілдік береді (ең көбі {{v3}}%).",
 "Пригласить друга": "Досты шақыру",
 "Привязать можно только нового клиента при его регистрации. Себя и уже зарегистрированных указать нельзя.": "Тек жаңа клиентті тіркелу кезінде байлауға болады. Өзіңізді және тіркелген клиенттерді көрсетуге болмайды.",
 "Ваши приглашённые": "Сіз шақырғандар",
 "Пока никого нет": "Әзірге ешкім жоқ",
 "Посылок за {{v0}} дн.": "{{v0}} күндегі сәлемдемелер",
 "Активен": "Белсенді",
 "Не активен": "Белсенді емес",
 "Не удалось загрузить настройки": "Баптауларды жүктеу мүмкін болмады",
 "Клиент приводит новых клиентов (они указывают его номер при регистрации) и получает скидку на вес. Приглашённый активен, если за период у него не меньше заданного числа посылок, прибывших на склад. С личным (VIP) тарифом скидка не действует.": "Клиент жаңа клиенттерді әкеледі (олар тіркелгенде оның нөмірін көрсетеді) және салмаққа жеңілдік алады. Шақырылған клиент кезеңде қоймаға келген сәлемдемелері белгіленген санға жетсе белсенді болады. Жеке (VIP) тарифпен жеңілдік қолданылмайды.",
 "Программа включена": "Бағдарлама қосулы",
 "Процент за одного активного, %": "Бір белсенді үшін пайыз, %",
 "Максимальная скидка, %": "Ең жоғары жеңілдік, %",
 "Минимум посылок у приглашённого": "Шақырылғандағы ең аз сәлемдеме",
 "Период активности, дней": "Белсенділік кезеңі, күн",
 "Программа действует для клиентов только тех филиалов, где она включена.": "Бағдарлама тек ол қосылған филиалдардың клиенттеріне қолданылады.",
 "Кто сколько привёл": "Кім қанша әкелді",
 "Приведено": "Әкелінген",
 "Активных": "Белсенді",
 "Скидка": "Жеңілдік",
 "выкл.": "өшірулі",
 "VIP-тариф": "VIP-тариф",
 "Адрес склада сохранён": "Қойма мекенжайы сақталды",
 "Адрес склада филиала": "Филиал қоймасының мекенжайы",
 "Этот адрес видит клиент в разделе «Склад», он же копируется кнопкой «Скопировать адрес склада». Вместо кода клиента пишите «КОД КЛИЕНТА» — подставится автоматически.": "Клиент бұл мекенжайды «Қойма» бөлімінде көреді, «Қойма мекенжайын көшіру» түймесі де соны көшіреді. Клиент коды орнына «КОД КЛИЕНТА» деп жазыңыз — автоматты түрде ауыстырылады.",
 "Адрес не задан — клиентам показывается общий адрес": "Көрсетілмеген — клиенттерге жалпы мекенжай көрсетіледі",
 "Сохранить адрес": "Мекенжайды сақтау",
 "Тарифы, реквизиты и история": "Тарифтер, деректемелер және тарих"
};

export default dict;
